import { createAction } from '@reduxjs/toolkit';

import {
  DOCUMENT_RENDER_TREE_INITIALIZE,
  DOCUMENT_RENDER_TREE_INSERT_NODE_TO_FIELD_NODE,
  DOCUMENT_RENDER_TREE_INSERT_NODE_TO_PAGE_ROOT,
  DOCUMENT_RENDER_TREE_REMOVE_NODE,
  DOCUMENT_RENDER_TREE_SET,
} from '@app/store/actionTypes';
import FieldNode from '@app/store/FieldNode';

import { RootInPage } from '.';

export const initializeDocumentRenderTree = createAction(DOCUMENT_RENDER_TREE_INITIALIZE);
export const insertNodeToFieldNode = createAction(
  DOCUMENT_RENDER_TREE_INSERT_NODE_TO_FIELD_NODE,
  (targetId: string, node: FieldNode) => {
    return {
      payload: {
        targetId,
        node,
      },
    };
  }
);

export const insertNodeToPageRootInDocumentRenderTree = createAction(
  DOCUMENT_RENDER_TREE_INSERT_NODE_TO_PAGE_ROOT,
  (page: number, node: FieldNode) => {
    return {
      payload: {
        page,
        node,
      },
    };
  }
);
export const setDocumentRenderTree = createAction<RootInPage>(DOCUMENT_RENDER_TREE_SET);
export const removeNodeFromDocumentRenderTree = createAction<string>(
  DOCUMENT_RENDER_TREE_REMOVE_NODE
);
